import { render, staticRenderFns } from "./send-message-x.vue?vue&type=template&id=4da4ff34&scoped=true"
import script from "./send-message-x.vue?vue&type=script&lang=js"
export * from "./send-message-x.vue?vue&type=script&lang=js"
import style0 from "./send-message-x.vue?vue&type=style&index=0&id=4da4ff34&prod&lang=scss&scoped=true"
import style1 from "./send-message-x.vue?vue&type=style&index=1&id=4da4ff34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4ff34",
  null
  
)

export default component.exports